<template>
  <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 16 16" fill="currentColor" width="24px">
    <path
      d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"
    />
    <path
      d="m 7.9947433,10.994744 c -0.2761424,0 -0.5,0.223857 -0.5,0.5 v 1.803513 l -1.146,-1.147 c -0.4720001,-0.471887 -1.1800001,0.236113 -0.7080001,0.708 l 2.0000001,2 c 0.1953639,0.195858 0.5126361,0.195858 0.708,0 l 1.9999997,-2 c 0.472,-0.472 -0.236,-1.18 -0.7079997,-0.708 l -1.146,1.147 v -1.803513 c 0,-0.276143 -0.2238576,-0.5 -0.5,-0.5 z"
    />
    <path
      d="m 7.9947433,5.0061498 c -0.2761424,0 -0.5,-0.223857 -0.5,-0.5 v -1.803513 l -1.146,1.147 c -0.4720001,0.471888 -1.1800001,-0.236113 -0.7080001,-0.708 L 7.6407433,1.1416373 c 0.1953639,-0.195858 0.5126361,-0.195858 0.708,0 l 1.9999997,1.9999995 c 0.472,0.472 -0.236,1.18 -0.7079997,0.708 l -1.146,-1.147 v 1.803513 c 0,0.276143 -0.2238576,0.5 -0.5,0.5 z"
    />
  </svg>
</template>
